const wsk = {
  page404: {
    title: "It seems like you got lost",
    message: "Did you get lost?",
    action_btn: "Back to the beginning"
  },
  address: {
    title: "Address",
    type: {
      personal: "Personal",
      company: "Company"
    },
    organisation: {
      label: "Company name"
    },
    name: {
      first_name: "First name",
      last_name: "Last name",
      label: "Contact person"
    },
    contact_person: {
      first_name: "First name",
      last_name: "Last name",
      label: "Contact person"
    },
    street: {
      label: "Street and number",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "City"
    },
    postal_code: {
      label: "Postal code"
    },
    country_code: {
      label: "Country"
    },
    company_data: {
      title: "Company data"
    },
    company_id: {
      label: "Company ID"
    },
    tax_id: {
      label: "Tax ID"
    },
    vat_id: {
      label: "VAT  ID"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "Email (you can enter more email addresses)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Phone",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Please enter your country",
    company_id: {
      not_valid: "Invalid company ID"
    },
    tax_id: {
      not_valid: "Invalid TaxID"
    },
    vat_id: {
      not_valid: "Invalid VAT ID"
    }
  },
  general: {
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    remove: "Remove",
    optional: "Optional",
    period: {
      months_one: "{count} month",
      years_one: "{count} year",
      months_few: "{count} months",
      years_few: "{count} years",
      months_other: "{count} months",
      years_other: "{count} years",
      explicit: "Period",
      short: {
        months: "{period} mes.",
        years_one: "year",
        years_few: "{count} yrs.",
        years_other: "{count} yrs."
      },
      next: {
        months_one: "next month",
        years_one: "next year",
        months_few: "next {count} months",
        years_few: "next {count} years",
        months_other: "next {count} months",
        years_other: "next {count} years",
        short: {
          months_one: "next month",
          years_one: "next year",
          months_few: "next {count} months",
          years_few: "next {count} yrs.",
          months_other: "next {count} months",
          years_other: "next {count} yrs."
        }
      },
      per: {
        months_one: "monthly",
        years_one: "yearly",
        months_few: "for {count} months",
        years_few: "for {count} years",
        months_other: "for {count} months",
        years_other: "for {count} years",
        short: {
          months_one: "/month",
          years_one: "/year",
          months_few: "/{count} months",
          years_few: "/{count} years",
          months_other: "/{count} months",
          years_other: "/{count} years"
        }
      }
    },
    or: "or",
    recommended: "recommended",
    settings: "Settings",
    edit: "Edit",
    save: "Save",
    save_changes: "Save changes",
    reset_form: "Reset form",
    not_available: "Not available",
    unknown_error: "Unknown error",
    unknown_error_id: "Unknown error ({id})",
    something_went_wrong: "We appologize, but this is unexpected result, something went wrong",
    link: "link",
    buy: "buy"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "is on"
  },
  ws_password_input: {
    expose_password: "Expose password"
  },
  ws_array_input: {
    incorrect_email: "Invalid email address(es)",
    incorrect_web: "Invalid web address(es)",
    some_filtered: "Some results are not valid."
  },
  ws_places_input: {
    no_results: "Place not found, please try a less specific address",
    start_typing: "Please start typing to see results"
  },
  ws_uploader: {
    validation: {
      file_type: "File type is not valid.",
      file_size: "File size is over limit ({limit})"
    },
    status: {
      label: "Status",
      value: {
        uploaded: "uploaded",
        uploading: "uploading",
        failed: "failed",
        idle: "idle"
      }
    },
    action: {
      title: "Upload invoices",
      text1: "Drag and drop or ",
      link: "choose file",
      text2: ".",
      abort_tooltip: "Abort upload"
    },
    supported_file_types: "Supported file types:",
    remove_btn: "Remove"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltext search",
      data_title: "Search",
      clear_filters: "Clear all filters",
      from: "From",
      to: "to"
    },
    label: {
      bulk_actions: "Bulk actions",
      cancel_selection: "Cancel selection",
      item_selected: "items selected",
      selected: "Selected",
      filterby: "Filter by:",
      records_per_page: "Records per page:",
      select_all: "Select all"
    }
  },
  ws_password_strength: {
    rule1: "a minimum of 8 characters",
    rule2: "lowercase and uppercase letters",
    rule3: "at least one digit",
    rule4: "at least one special character"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Passwords do not match!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "You can resend the code again in {count} second.",
    on_cooldown_few: "You can resend the code again in {count} seconds.",
    on_cooldown_other: "You can resend the code again in {count} seconds.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code.",
    invalid_code_pasted: "Invalid 2FA code was pasted. Please enter a valid 2FA code."
  },
  generate_random: "Generate random",
  copy: {
    copy: "Copy",
    copied: "Copied",
    saved_in_clipboard: "Saved in clipboard"
  },
  out_modal: {
    title: "Sorry, your browser<br>is not up to date",
    text: "Please upgrade it to the newest version or try installing a different browser.",
    delimiter_text: "We can help"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active",
    issued_by: "This card was issued by {issuer}."
  },
  ws_sub_items_price_summary: {
    current_price: "Service price (the current billing period)",
    due_now: "Due now",
    next_period_subtraction_warning: "* The price will be deducted from the next billing period",
    next_price: "Service price (the next billing period)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(including VAT)",
    excluding_vat: "(without VAT)"
  },
  cart_item: {
    notices: {
      business_mail: {
        license_count_increase: {
          title: "Your domain already contains some mailboxes",
          text_one: "You currently have {count} mailbox on this domain. To use Business Mail, you need to order at least this number of licenses.",
          text_few: "You currently have {count} mailboxes on this domain. To use Business Mail, you need to order at least this number of licenses.",
          text_other: "You currently have {count} mailboxes on this domain. To use Business Mail, you need to order at least this number of licenses."
        },
        free_trial: {
          title: "Start your 60-day free trial today!",
          text: "A free trial is automatically activated for each Business Mail service, which allows you to test the highest Premium license."
        },
        free_trial_postfix: {
          title: "Start your 60-day free trial today!",
          text_one: "We automatically activate a 60-day trial for each hosted mailbox we migrate to our Business Mail service, so you can test out our Premium license for free. Please note you have to order at least as many Premium licenses as the number of mailboxes you are migrating. (You have 1 mailbox). <b>The migration may affect the content of the mailbox (contacts/calendars), so we recommend you review the process of <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> how the migrations to Business Mail work</a> before ordering the service.</b>",
          text_few: "We automatically activate a 60-day trial for each hosted mailbox we migrate to our Business Mail service, so you can test out our Premium license for free. Please note you have to order at least as many Premium licenses as the number of mailboxes you are migrating. (You have {count} mailboxes). <b>The migration may affect the content of the mailbox (contacts/calendars), so we recommend you review the process of <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> how the migrations to Business Mail work</a> before ordering the service.</b>",
          text_other: "We automatically activate a 60-day trial for each hosted mailbox we migrate to our Business Mail service, so you can test out our Premium license for free. Please note you have to order at least as many Premium licenses as the number of mailboxes you are migrating. (You have {count} mailboxes). <b>The migration may affect the content of the mailbox (contacts/calendars), so we recommend you review the process of <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> how the migrations to Business Mail work</a> before ordering the service.</b>"
        },
        free_trial_premium_licenses_notice: {
          title_one: "You need at least 1 Premium license for the migration to Business Mail",
          title_few: "You need at least {count} Premium licenses for the migration to Business Mail",
          title_other: "You need at least {count} Premium licenses for the migration to Business Mail",
          text: "To make it easier for you, we have automatically added the required number of Premium licenses, unless you did so in the previous step. <b>The migration may affect the content of the mailbox (contacts/calendars), so we recommend you to review the process of <a href='https://www.example.com' target='_blank'>how the migration process to Business Mail works</a> before ordering the service.</b>"
        }
      }
    }
  },
  login_pages: {
    footer: {
      help: "Help",
      terms: "Terms",
      privacy: "Privacy"
    },
    help: {
      title: "Need any help?",
      text: "You can always have a look at our <a href='{kb_url}' target='_blank'>knowledge database </a> or contact our <a href='{support_url}' target='_blank'>support</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      status_401: {
        text: "You don't have the required permissions."
      },
      status_403: {
        text: "Access denied."
      },
      status_404: {
        title: "Not found.",
        text: "Source not found."
      },
      status_407: {
        text: "Please login via the Legacy Active24 login page."
      },
      status_408: {
        text: "Connection timeout."
      },
      status_500: {
        text: "Uh oh, something went wrong. Please contact our support."
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  },
  ws_input: {
    invalid_phone_number: "Invalid phone number",
    phone_missing: "Phone is required"
  },
  ws_google_autocomplete: {
    no_results: "Place not found, please try a less specific address"
  }
};
const wsk_enUS = {
  wsk
};
export {
  wsk_enUS as default,
  wsk
};
//# sourceMappingURL=wsk.en-US.json.es.js.map
